var rootPage = $('body').data('rootpage');